<template>
    <div class="othersEmployeeConfig">
        <el-button
            size="small"
            type="primary"
            icon="el-icon-plus"
            @click="addEvent"
            style="margin-bottom: 10px"
        >
            新增配置
        </el-button>
        <filter-box
            channel="others"
            @reset="resetEvent"
            @search="searchEvent"
        ></filter-box>
        <div class="tableList">
            <!-- 表格部分 -->
            <el-table
                v-loading="tableLoading"
                :data="tableData"
                style="width: 100%"
                class="table-box"
                :header-cell-style="{
                    background: '#F5F5F5',
                    color: '#606266',
                }"
            >
                <el-table-column
                    prop="member_id"
                    label="会员ID"
                    min-width="100"
                >
                </el-table-column>
                <el-table-column prop="channel_id" label="渠道" min-width="100">
                    <template slot-scope="{ row }">
                        <span>{{ getChannelName(row.channel_id) }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="channel_merchant_id"
                    label="渠道用户"
                    min-width="100"
                >
                </el-table-column>
                <el-table-column label="详细配置" min-width="300">
                    <template slot-scope="{ row }">
                        <el-tooltip
                            popper-class="detailPopper"
                            effect="dark"
                            :content="row.detail_config"
                            placement="top"
                        >
                            <div
                                style="
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                "
                            >
                                <span style="white-space: nowrap">
                                    {{ row.detail_config }}
                                </span>
                            </div>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="create_time"
                    label="创建日期"
                    min-width="100"
                >
                </el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                      <el-button
                          type="text"
                          style="padding: 0; color: #4d7efa"
                          class="f14h20w400"
                          @click="detectEvent(scope.row)"
                      >
                        检测
                      </el-button>
                        <el-button
                            type="text"
                            style="padding: 0; color: #4d7efa"
                            class="f14h20w400"
                            @click="editEvent(scope.row)"
                        >
                            编辑
                        </el-button>
                        <el-button
                            type="text"
                            style="padding: 0; color: #4d7efa"
                            class="f14h20w400"
                            @click="delEvent(scope.row)"
                        >
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="page-box">
                <el-pagination
                    @current-change="fetchList"
                    :current-page.sync="page"
                    :page-size.sync="pageSize"
                    layout="total, prev, pager, next, jumper"
                    :total="total"
                >
                </el-pagination>
            </div>
        </div>
        <others-dialog
            :visible.sync="dialogVisible"
            :actionType="dialogType"
            :configData="currentRow"
            @refresh="refreshList"
        ></others-dialog>
      <el-dialog
          v-if="checkDialogVisible"
          :visible="checkDialogVisible"
          :show-close="false"
          width="660px"
          :close-on-click-modal="false"
      >
        <div class="dialog">
          <!-- 使用统一的 dialogHeader -->
          <dialogHeader
              title="检测配置"
              @closeDialog="onCloseCheckDialog"
          ></dialogHeader>

          <!-- 表单内容 -->
          <div class="dialogList">
            <el-form label-width="120px" :model="checkForm">
              <!-- 支付方式 -->
              <el-form-item label="支付方式">
                <el-select v-model="checkForm.payMethod" placeholder="请选择支付方式">
                  <el-option label="被扫支付" value="microPay"></el-option>
                  <el-option label="小程序支付" value="jsApiAppForMiniApp"></el-option>
                </el-select>
              </el-form-item>

              <!-- 被扫支付：付款码 -->
              <div v-if="checkForm.payMethod === 'microPay'">
                <el-form-item label="付款码">
                  <el-input v-model="checkForm.authCode" placeholder="请输入付款码"></el-input>
                </el-form-item>
              </div>

              <!-- 条件渲染 APPID 和 OPENID -->
              <div v-if="checkForm.payMethod === 'jsApiAppForMiniApp'">
                <el-form-item label="APPID">
                  <el-input v-model="checkForm.appId" placeholder="请输入APPID"></el-input>
                </el-form-item>
                <el-form-item label="OPENID">
                  <el-input v-model="checkForm.openId" placeholder="请输入OPENID"></el-input>
                </el-form-item>
              </div>
            </el-form>

            <!-- 错误提示 -->
            <div v-if="errorMessage" style="color: red; text-align: center; margin-top: 10px;">
              {{ errorMessage }}
            </div>
          </div>

          <!-- 按钮区域 -->
          <div slot="footer" class="dialog-footer" flex="cross:center main:right">
            <el-button size="small" @click="onCloseCheckDialog">取 消</el-button>
            <el-button type="primary" size="small" :loading="checkLoading" @click="reqDetectApi">测 试</el-button>
          </div>
        </div>
      </el-dialog>


    </div>
</template>

<script>
import { MessageBox } from "element-ui";
import {getCommonConfigList, delCommonConfig, detectMerchantPayConfig} from "@/api/config";
import * as initStore from "@/store/init.js";
import FilterBox from "./components/filterBox.vue";
import OthersDialog from "./components/othersDialog.vue";

export default {
    components: {
        FilterBox,
        OthersDialog,
    },
    data() {
        return {
            page: 1,
            pageSize: 10,
            total: 0,
            tableLoading: false,
            tableData: [],
            searchParams: {
                member_id: "",
            },
            dialogVisible: false,
            dialogType: "add",
            currentRow: null,
          checkDialogVisible: false,
          checkLoading: false,
          checkForm: {
            payMethod: '',     //支付方法
            authCode: '',   //付款码
            appId: '',     // APPID
            openId: ''     // OPENID
          },
          errorMessage: ''
        };
    },
    computed: {
        channelList: () => initStore.state.channelList, //渠道列表
    },
    mounted() {
        this.fetchList();
    },
    methods: {
        getChannelName(id) {
            const channel = this.channelList.find((c) => c.channel_id == id);
            if (channel) {
                return channel.channel_name;
            }
            return "";
        },
        async fetchList() {
            let { page, pageSize } = this;
            let { member_id, channel_id } = this.searchParams;
            let params = {
                page,
                page_size: pageSize,
                member_id,
                channel_id,
            };
            this.tableLoading = true;
            const res = await getCommonConfigList(params);
            this.tableLoading = false;
            if (res.code != 200) return;
            let { list, total } = res.data;
            this.tableData = list || [];
            this.total = parseInt(total);
        },
        addEvent() {
            this.dialogType = "add";
            this.dialogVisible = true;
        },
        editEvent(val) {
            this.currentRow = val;
            this.dialogType = "edit";
            this.dialogVisible = true;
        },
        delEvent({ id }) {
            MessageBox.confirm("您确定要删除该渠道配置？", "提示", {
                type: "warning",
            })
                .then(async () => {
                    this.tableLoading = true;
                    const res = await delCommonConfig({ id });
                    if (res.code == 200) {
                        this.$message.success("删除成功");
                        this.page = 1;
                        this.fetchList();
                    }
                })
                .catch((e) => {
                    this.tableLoading = false;
                    this.$message.error(e.msg);
                });
        },
        resetEvent(params) {
            this.searchParams = params;
        },
        searchEvent(params) {
            this.page = 1;
            this.searchParams = params;
            this.fetchList();
        },
        refreshList() {
            if (this.dialogType === "add") {
                this.page = 1;
                this.fetchList();
            } else {
                this.fetchList();
            }
        },
      onCloseCheckDialog() {
        this.checkDialogVisible = false;
        this.errorMessage = '';
        this.checkForm = {
          payMethod: '',
          authCode: '',
          appId: '',
          openId: ''
        };
      },

      detectEvent(val) {
         this.checkForm = {
           payMethod: '',
           authCode: '',
           appId: '',
           openId: '',
         };
         this.errorMessage = '';
         this.currentRow = val;
         this.checkDialogVisible = true;
       },
       async reqDetectApi() {
         const { payMethod, authCode, appId, openId } = this.checkForm;
         const params = {
           pay_method: payMethod,
           app_id: appId,
           open_id: openId,
           auth_code: authCode,
           channel_id: this.currentRow.channel_id,
           member_id: this.currentRow.member_id,
           channel_merchant_id: this.currentRow.channel_merchant_id,
         };
         if (payMethod === 'jsApiAppForMiniApp' && (!appId || !openId)) {
           this.errorMessage = '请填写完整的 APPID 和 OPENID';
           return;
         }
         if (payMethod === 'microPay' && (!authCode)) {
           this.errorMessage = '请填写付款码';
           return;
         }
         this.checkLoading = true;
         try {
           const res = await detectMerchantPayConfig(params);
           if (res.data.code !== 200) {
             let errorMsg = '接口请求失败，请检查参数';

             // 提取支付结果错误信息
             const payRes = res.data.pay_res || {};
             const payResMsg = payRes.code !== 200 ? `支付结果：${payRes.msg || ''}` : '';

             // 提取退款结果错误信息
             const refundRes = res.data.refund_res || {};
             const refundResMsg = refundRes.code !== 200 ? `退款结果：${refundRes.msg || ''}` : '';

             // 拼接错误信息
             const detailMsg = [payResMsg, refundResMsg].filter(msg => msg).join('\n');

             if (detailMsg) {
               errorMsg += `\n${detailMsg}`;
             }

             this.errorMessage = errorMsg;
           } else {
             this.errorMessage = '测试成功！';
           }
         } catch (error) {
           this.errorMessage = error.response?.data?.msg || '网络异常，请重试';
         } finally {
           this.checkLoading = false;
         }
       },
    },
};
</script>

<style lang="scss">
.detailPopper {
    max-width: 80%;
}
</style>
